import(/* webpackMode: "eager" */ "/vercel/path0/app/(lobby)/budget/page.tsx");
